jQuery(document).ready(function($) {
  
  var slick_defaults = {
          lazyLoad: 'progressive',
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
        };
  
  $('.slick').each(function(){
    var slick_div = $(this),
        widget = slick_div.parent(),
        slick_id = $(this).attr('id'),
    	slick_captions = $('#'+slick_id+'-captions'),
    	slick_opensite = $('#'+slick_id+'-opensite'),
    	slick_videos = slick_div.find('iframe');

    slick_div.slick(slick_defaults);
    var slick_dots = $('.slick-dots');
	slick_div.on('setPosition', function(slick){ 
      // on resize
    });
    slick_div.find('.close-caption').click(function(){
      if(widget.hasClass('contain')) slick_div.addClass('hidecaption');
    });
	slick_div.find('.open-caption').click(function(){
	  if(widget.hasClass('contain')) slick_div.removeClass('hidecaption');
    });
    slick_div.on('beforeChange', function(slick, currentSlide, index){
      var active_slide = currentSlide.$slides.eq(index);
      active_slide.find('iframe').each(function(){
        $(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');    
      });
      
    });
    slick_div.on('afterChange',function(slick, currentSlide, index){
      var active_slide = currentSlide.$slides.eq(index),
          slide_caption = active_slide.find('.caption').html();
      if(!slick_div.hasClass('contain') && slide_caption) { 
        slick_captions.html(slide_caption);
      }
      if(active_slide.hasClass('video')) {
        slick_dots.fadeOut();
        slick_opensite.fadeOut();
      } else {
        slick_dots.fadeIn();
        slick_opensite.fadeIn();
      }
    });
  });
});